import { createVanIconComponent } from "./van"

const Descending = createVanIconComponent("descending")
export default Descending
